import pako from 'pako'

/**
 * Compress text
 *
 * @param {String} data
 * @return {String}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function compressText (data) {
  return pako.gzip(data, {to: 'string'})
}

/**
 * Decompress text
 *
 * @param {String} data
 * @return {String}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function decompressText (data) {
  return pako.ungzip(data, {to: 'string'})
}

/**
 * Compress file
 *
 * @param {ArrayBuffer} data
 * @return {ArrayBuffer}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function compressFile (data) {
  return pako.gzip(data).buffer
}

/**
 * Decompress file
 *
 * @param {ArrayBuffer} data
 * @return {ArrayBuffer}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function decompressFile (data) {
  return pako.ungzip(data).buffer
}
